import { render } from "./MentorHome.vue?vue&type=template&id=394f298b"
import script from "./MentorHome.vue?vue&type=script&lang=js"
export * from "./MentorHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__